import script from "./EducationsDrawer.vue?vue&type=script&setup=true&lang=js"
export * from "./EducationsDrawer.vue?vue&type=script&setup=true&lang=js"

import "./EducationsDrawer.vue?vue&type=style&index=0&id=64e4593a&lang=scss"

const __exports__ = script;

export default __exports__